import React from 'react';
import ArticleModal from "./articleModal";
import '../../style/dots.css';
import Dots from 'react-activity/lib/Dots';
import Autosuggest from "react-autosuggest";
import {TABLE_VIEW_OPTIONS} from "../../helpers/variables";
import CustomTable from "../General/customTable/CustomTable";
import moment from "moment";
import '../../style/solicitorArticlesList.css'

const columns = [
    {propertyName: "title", header: "Title"},
    { propertyName: "createdAt", header: "Date", formatter: (row) => moment(row.createdAt).format("DD/MM/YYYY") },
];

const SolicitorArticlesList = (props) => {

    if(props.solicitorArticlesList.fetchingInfoMessage){
        return(
            <div className="">
                <div className="col-sm-3"></div>
                <div className="col-sm-6">
                    <div className="col-sm-5"></div>
                    <Dots/>
                </div>
            </div>
        )
    }

    let calcOffset =props.solicitorArticlesList.displayAmount*(props. solicitorArticlesList.page -1);
    let parameters = {
        limit: props.solicitorArticlesList.selectedView,
        offset: calcOffset>0? calcOffset:0,
        published: true,
        unpublished: false,
        search: props.solicitorArticlesList.value
    };

    return (
        <div className="form-group">
            {
                props.solicitorArticlesList.openModal ?
                    <div className="appFormRefSettings-modal">
                        <div className="solicitorArticlesList-modal-content">
                            <div className="appFormRefSettings-close-button" onClick={()=>{
                                props.changeSolicitorArticlesListSettings('articleInModalId',{});
                                props.changeSolicitorArticlesListSettings('openModal',false)
                            }
                            }/>
                            <ArticleModal
                                requestGetArticleAttachment = {props.requestGetArticleAttachment}
                                article={props.solicitorArticlesList.articleInModal}
                                changeSolicitorArticlesListSettings={props.changeSolicitorArticlesListSettings}
                            />
                        </div>
                    </div>
                    :
                    null
            }
            <div className="">
                <div className="row">
                    <div className="col-sm-12">
                        <h2 className="header2Style">Articles</h2>
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-12">
                        <p className="generalText">
                            {props.solicitorArticlesList.infoMessage}
                        </p>
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-12">
                        <hr className="appFormRefSettings-hr"/>
                    </div>
                </div>
               <div className={"row"}>
                   <div className="form-group">
                       <div className="col-sm-2">
                           <label className={'control-label.text-left formGroupSelectInput-label'}>
                               {"Search"}
                           </label>
                       </div>
                       <div className="col-sm-6"
                            onKeyPress={(evt) => evt.key === 'Enter' ? props.getArticles(parameters) : null}

                       >
                           <Autosuggest
                               suggestions={props.suggestions}
                               onSuggestionsFetchRequested={props.onSuggestionsFetchRequested}
                               onSuggestionsClearRequested={props.onSuggestionsClearRequested}
                               getSuggestionValue={props.getSuggestionValue}
                               renderSuggestion={props.renderSuggestion}
                               inputProps={props.inputProps}
                               onSuggestionSelected={props.onSuggestionSelected}
                               theme={{
                                   container: 'agents-list-action-autoSuggest-container',
                                   input: 'applicationsAndPolicies-autosuggest',
                                   suggestionsContainer: 'applicationsAndPolicies-autosuggest-suggestionsContainer',
                                   suggestionsList: 'applicationsAndPolicies-autosuggest-suggestionsList',
                                   suggestion: 'applicationsAndPolicies-autosuggest-suggestion',
                                   suggestionHighlighted: 'applicationsAndPolicies-autosuggest-suggestion-highLighted'
                               }}
                           />
                           <div className="applicationsAndPolicies-autosuggest-search-icon"
                                onClick={props.handleAutoSuggestButton}>
                               <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><title>Asset 6</title>
                                   <g id="Layer_2" data-name="Layer 2">
                                       <g id="info">
                                           <path
                                               d="M15.61,13.72l-3.48-3.48-.06,0a6.58,6.58,0,1,0-1.88,1.88l0,.06,3.48,3.48a1.34,1.34,0,0,0,1.89-1.89Zm-9-2.84a4.3,4.3,0,1,1,4.3-4.3A4.3,4.3,0,0,1,6.58,10.88Z"/>
                                       </g>
                                   </g>
                               </svg>
                           </div>
                       </div>
                   </div>
               </div>
                <div className="row">
                    <div className="col-sm-12">
                        {
                            props.solicitorArticlesList.articles.length > 0?
                                <div>
                                    <CustomTable
                                        accordionItemHeaderFormatter={(row) => (
                                            `Title: ${row.title} Date: ${moment(row.createdAt).format("DD/MM/YYYY")}`
                                        )}
                                        onPageSizeChange={(evt) => props.changeSolicitorArticlesListSettings(evt.target.name, evt.target.value)}
                                        goAtPage={props.changeSolicitorArticlesListSettings}
                                        onPageShift={props.pageShiftSolicitorArticles}
                                        loading={props.solicitorArticlesList.fetching}
                                        responsive
                                        striped
                                        columns={columns}
                                        data={props.solicitorArticlesList.articles}
                                        pageSize={parseInt(props.solicitorArticlesList.selectedView)}
                                        totalRecords={props.solicitorArticlesList.totalRecords}
                                        totalPages={parseInt(props.solicitorArticlesList.totalBoxes)}
                                        page={props.solicitorArticlesList.page}
                                        hasActions
                                        actions={[
                                            {
                                                key: 'readArticle',
                                                label: 'Read Article',
                                                callback: (row)=>{
                                                    props.changeSolicitorArticlesListSettings('articleInModal', row);
                                                    props.changeSolicitorArticlesListSettings('openModal',true)}
                                            }
                                        ]}
                                        pageSizeOptions={TABLE_VIEW_OPTIONS}
                                    />
                                </div>
                                :
                                <div className="text-center">
                                    <span>No article to show.</span>
                                </div>
                        }
                    </div>
                </div>
            </div>
        </div>
    )
};

export default SolicitorArticlesList;